<svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5399e-08 8L8 9.5399e-08L8 16L9.5399e-08 8Z" fill="#212328"/>
</svg>
